<div class="dialog-title-row">
  <h2 mat-dialog-title>Services</h2>
  <button mat-icon-button type="button" (click)="toggleEditing()"
          [attr.aria-label]="editingUnlocked ? 'Bearbeiten sperren' : 'Bearbeiten freischalten'"
          [matTooltip]="editingUnlocked ? 'Bearbeiten sperren' : 'Bearbeiten freischalten'">
    <mat-icon [svgIcon]="editingUnlocked ? 'lock-keyhole-open' : 'lock-keyhole'"></mat-icon>
  </button>
  <button mat-icon-button mat-dialog-close class="dialog-close-button" aria-label="Schließen" matTooltip="Schließen">
    <mat-icon svgIcon="xmark"></mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (loading) {
    <div class="loading">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else if (errorMessage) {
    <p class="error-banner">{{ errorMessage }}</p>
  } @else {
    <table mat-table [dataSource]="rows" class="service-configurations-table">
      <ng-container matColumnDef="configName">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let row" [class.clickable-name]="isNarrowScreen"
            [matTooltip]="row.original.comment ?? ''" [matTooltipDisabled]="!row.original.comment"
            (click)="openDetails(row)">
          {{ row.original.niceText || row.original.configName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="stringValue">
        <th mat-header-cell *matHeaderCellDef>Text</th>
        <td mat-cell *matCellDef="let row">
          @if (row.original.stringValue === null) {
            <span class="hint">–</span>
          } @else if (editingUnlocked) {
            <input class="value-input" [(ngModel)]="row.stringValue" maxlength="2000"
                   (dblclick)="editText(row)" matTooltip="Doppelklick: Text bearbeiten (Markdown)" />
          } @else {
            <span class="text-preview">{{ row.stringValue }}</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="integerValue">
        <th mat-header-cell *matHeaderCellDef>Zahl</th>
        <td mat-cell *matCellDef="let row">
          @if (row.original.integerValue === null) {
            <span class="hint">–</span>
          } @else if (editingUnlocked) {
            <input class="value-input value-input--number" type="number" [(ngModel)]="row.integerValue" />
          } @else {
            {{ row.integerValue }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="doubleValue">
        <th mat-header-cell *matHeaderCellDef>Betrag</th>
        <td mat-cell *matCellDef="let row">
          @if (row.original.doubleValue === null) {
            <span class="hint">–</span>
          } @else if (editingUnlocked) {
            <input class="value-input value-input--number" type="text" inputmode="decimal"
                   [(ngModel)]="row.doubleValueText" (ngModelChange)="onDoubleValueTextChange(row, $event)" />
          } @else {
            {{ row.doubleValue }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="boolValue">
        <th mat-header-cell *matHeaderCellDef>Ja/Nein</th>
        <td mat-cell *matCellDef="let row">
          @if (row.original.boolValue === null) {
            <span class="hint">–</span>
          } @else if (editingUnlocked) {
            <mat-slide-toggle [(ngModel)]="row.boolValue" [disabled]="isLockedByBackendService(row)"
                              [matTooltip]="isLockedByBackendService(row) ? 'Erst den backendService einschalten und speichern' : ''"></mat-slide-toggle>
          } @else {
            <mat-icon class="status-dot" [class.status-dot--green]="row.boolValue"
                      [class.status-dot--red]="!row.boolValue"
                      [matTooltip]="row.boolValue ? 'Ja' : 'Nein'"
                      [attr.aria-label]="'Ja/Nein: ' + (row.boolValue ? 'Ja' : 'Nein')" svgIcon="circle-sharp-solid"></mat-icon>
          }
          @if (isNarrowScreen && editingUnlocked && isDirty(row)) {
            <button mat-icon-button [disabled]="row.saving" aria-label="Speichern" matTooltip="Speichern"
                    (click)="saveRow(row)">
              <mat-icon svgIcon="floppy-disk"></mat-icon>
            </button>
            <button mat-icon-button [disabled]="row.saving" aria-label="Verwerfen" matTooltip="Verwerfen"
                    (click)="resetRow(row)">
              <mat-icon svgIcon="xmark"></mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="lastModified">
        <th mat-header-cell *matHeaderCellDef>Geändert</th>
        <td mat-cell *matCellDef="let row">
          @if (editingUnlocked && isDirty(row)) {
            <button mat-icon-button [disabled]="row.saving" aria-label="Speichern" matTooltip="Speichern"
                    (click)="saveRow(row)">
              <mat-icon svgIcon="floppy-disk"></mat-icon>
            </button>
            <button mat-icon-button [disabled]="row.saving" aria-label="Verwerfen" matTooltip="Verwerfen"
                    (click)="resetRow(row)">
              <mat-icon svgIcon="xmark"></mat-icon>
            </button>
          } @else {
            {{ row.original.lastModified | date:'dd.MM.yyyy HH:mm:ss' }}
            @if (row.original.lastModifiedByName) {
              <br /><span class="hint">{{ row.original.lastModifiedByName }}</span>
            }
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  }
</mat-dialog-content>
